import axios from 'axios';
import history from '../../history'; // Import the custom history instance
import { userLogout } from '../../components/Login/LoginService';
import { v4 as uuidv4 } from 'uuid';

// Function to set up Axios interceptors
export const configureAxiosInterceptors = (setIsLoading) => {
  // Set base URL globally
  axios.defaults.baseURL = window.env.REACT_APP_BACKEND_URL;
  axios.defaults.headers.common['Content-Type'] = 'application/json';

  axios.interceptors.request.use(
    (config) => {
      const correlationId = uuidv4();
      let storedUser = JSON.parse(sessionStorage.getItem('user'));
      config.headers['X-Correlation-ID'] = correlationId;
      const auth = storedUser?.access_token ? 'Bearer ' + storedUser.access_token : null;
      const token = sessionStorage.getItem('authorizationToken');
      auth && (config.headers['Authorization'] = auth);
      token && (config.headers['X-Authorization-Token'] = token);

      storedUser?.profile?.preferred_username &&
        (config.headers['Username'] = storedUser.profile.preferred_username);

      storedUser?.profile?.email &&
        (config.headers['Email'] = storedUser.profile.email);


      return config;
    },
    null,
    { synchronous: true }
  );
  // Response interceptor
  axios.interceptors.response.use(
    (response) => response, // Simply return the response if successful
    async (error) => {
      // Commenting out the 401 error handling for now
      // if (error.response && error.response.status === 401) {
      //   console.error('Unauthorized: Access denied...', error.response.status);
      //   // Start the loader
      //   setIsLoading(true);
      //   let data = {
      //     token: sessionStorage.getItem('authorizationToken'),
      //   };
      //   await userLogout(data).then(() => {
      //     sessionStorage.clear();
      //     localStorage.clear();
      //     setTimeout(() => {
      //       setIsLoading(false); // Stop the loader after redirect
      //       history.replace('/access-error');
      //     }, 3000);
      //   });
      // }
      return Promise.reject(error);
    }
  );
};
